/**
 * Whether a listings query narrows the catalogue at all. A blank search box is
 * not a filter, so an empty result without one means there are no listings yet.
 */
export function hasActiveFilters(filters: object): boolean {
  return Object.values(filters).some(
    (v) => v !== undefined && v !== null && !(typeof v === 'string' && v.trim() === '')
  );
}
